import translator from '@Components/Utilities/Translator';
import TranslationText from '@Components/Utilities/TranslationText';
import MyListingsPostings from '@Components/Account/MyListingsPostings';
import UserSettingSelector from '@Components/Shared/UserSettingSelector';
import { useRecoilValue } from 'recoil';
import atoms from '@Components/Utilities/SandhillsAtoms';

const SetPreferences = (props) => {
    const currentSite = useRecoilValue(atoms.currentWebsite);

    return (
        <div>
            <div className='email-alerts-container'>
                <div className='want-to-buy-form grey-box'>
                    <h4>
                        <TranslationText tKey='sandhills.tradesites.mvc.mypreferences' />
                    </h4>
                    <UserSettingSelector
                        {...props}
                        submitButtonText={translator.translate('sandhills.photosvideos.savechanges')}
                        useRowView
                        ShowCurrencySelector
                    />
                </div>
            </div>
            {!currentSite?.Site?.IsAuctionSite &&
                <MyListingsPostings {...props.MyListingsPostings} />
            }
        </div>
    );
};

export default SetPreferences;